import createAxiosInstance from './Axios';

export const callMotivesValidationProducts = (data, baseURL) => {
  const axiosInstance = createAxiosInstance(baseURL);

  return axiosInstance({
    url: `/form/validation/product`,
    method: 'post',
    data: data,
  });
};
